import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import logoImg from "../assets/logo2.png";

export const exportarTurmas = (
  turmasFiltradas,
  formato,
  titulo = "Turmas",
  operador = "Operador desconhecido"
) => {
  const nomeEscola = "Escola Vida Abundante";
  const desenvolvedor = "Chaúca Creative";
  const dataAtual = new Date().toLocaleDateString("pt-AO");

  // ✅ Função para normalizar o texto do gênero
  const formatarGenero = (genero) => {
    if (!genero) return "-";
    const g = genero.toString().trim().toLowerCase();
    if (["m", "masculino", "h"].includes(g)) return "Masculino";
    if (["f", "feminino"].includes(g)) return "Feminino";
    return genero.charAt(0).toUpperCase() + genero.slice(1).toLowerCase();
  };

  // ✅ Função para contar H/M corretamente
  const contarGeneros = (alunos) => {
    let homens = 0, mulheres = 0;
    alunos.forEach(a => {
      const g = (a.genero || "").toString().trim().toLowerCase();
      if (["m", "masculino", "h"].includes(g)) homens++;
      else if (["f", "feminino"].includes(g)) mulheres++;
    });
    return { homens, mulheres };
  };

  if (formato === "pdf") {
    const doc = new jsPDF();

    Object.keys(turmasFiltradas).forEach((turmaKey, index) => {
      const alunos = turmasFiltradas[turmaKey];
      if (!alunos.length) return;

      const ano = alunos[0]?.ano_criacao || new Date().getFullYear();
      const classe = alunos[0]?.classe || "-";
      const tituloTabela = `Turma ${turmaKey}, ${classe}, ${ano}`;

      const total = alunos.length;
      const { homens, mulheres } = contarGeneros(alunos);

      // Cabeçalho e rodapé
      const gerarCabecalhoRodape = (data) => {
        // Logo
        if (logoImg) {
          const img = new Image();
          img.src = logoImg;
          doc.addImage(img, "PNG", 10, 10, 25, 25);
        }

        // Nome da escola
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(nomeEscola, 40, 18);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        doc.text(`Relatório gerado em: ${dataAtual}`, 40, 28);

        // Título da turma
        doc.setFont("helvetica", "bold");
        doc.setFontSize(13);
        doc.text(`${tituloTabela} | Total: ${total} (H:${homens} / M:${mulheres})`, 14, 45);

        // Rodapé
        const pageHeight = doc.internal.pageSize.height;
        const pageWidth = doc.internal.pageSize.width;
        const pageNumber = doc.internal.getNumberOfPages();

        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text(
          `Software: ACADE-Gestor Escolar | Operador: ${operador} | Data: ${dataAtual} | Página ${pageNumber}`,
          14,
          pageHeight - 15
        );
        doc.setDrawColor(150);
        doc.line(14, pageHeight - 13, pageWidth - 14, pageHeight - 13);

        doc.setFont("helvetica", "italic");
        doc.text(`Desenvolvido por ${desenvolvedor}`, pageWidth - 14, pageHeight - 8, { align: "right" });
      };

      const colunas = ["Nº", "Nome completo", "Gênero", "Código", "Classe", "Idade"];
      const dados = alunos.map(a => [
        a.numero,
        a.nome_completo || a.nome,
        formatarGenero(a.genero), // ✅ Formata o gênero corretamente
        a.codigo || "-",
        a.classe,
        a.idade || "-"
      ]);

      autoTable(doc, {
        startY: 50,
        head: [colunas],
        body: dados,
        styles: { fontSize: 10, cellPadding: 3 },
        headStyles: { fillColor: [22, 160, 133], textColor: 255, halign: "center" },
        columnStyles: {
          0: { cellWidth: 15, halign: "center" },
          1: { cellWidth: 70 },
          2: { cellWidth: 25, halign: "center" },
          3: { cellWidth: 30, halign: "center" },
          4: { cellWidth: 25, halign: "center" },
          5: { cellWidth: 20, halign: "center" },
        },
        didDrawPage: gerarCabecalhoRodape
      });

      if (index < Object.keys(turmasFiltradas).length - 1) doc.addPage();
    });

    doc.save(`${titulo}_${dataAtual}.pdf`);
  }

  if (formato === "excel" || formato === "csv") {
    const workbook = XLSX.utils.book_new();

    Object.keys(turmasFiltradas).forEach((turmaKey) => {
      const alunos = turmasFiltradas[turmaKey];
      if (!alunos.length) return;

      const ano = alunos[0]?.ano_criacao || new Date().getFullYear();
      const classe = alunos[0]?.classe || "-";
      const tituloTabela = `Turma ${turmaKey}, ${classe}, ${ano}`;

      const dadosExport = alunos.map(a => ({
        Nº: a.numero,
        "Nome completo": a.nome_completo || a.nome,
        Gênero: formatarGenero(a.genero), // ✅ Formata gênero
        Código: a.codigo || "-",
        Classe: a.classe,
        Idade: a.idade || "-"
      }));

      const worksheet = XLSX.utils.json_to_sheet(dadosExport);
      XLSX.utils.book_append_sheet(workbook, worksheet, tituloTabela);
    });

    const fileType = formato === "excel" ? "xlsx" : "csv";
    XLSX.writeFile(workbook, `${titulo}_${dataAtual}.${fileType}`);
  }
};
